import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import classnames from "classnames";
import get from "lodash/get";
import { useStyles } from "./Typography.styles.js";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function Typography_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else Typography_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
function _object_without_properties(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys, key, i;
    if ("u" > typeof Reflect && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (!(excluded.indexOf(key) >= 0)) {
            if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
        }
    }
    return target;
}
const variantMapping = {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    subtitle1: 'h6',
    subtitle2: 'h6',
    body1: 'div',
    body2: 'div'
};
const Typography_Typography = /*#__PURE__*/ forwardRef((_0, _1)=>{
    let _ref = [
        _0,
        _1
    ], [_ref1, ..._rest] = _ref, { variant = 'body1', color = 'text.light.primary', className, lineHeight, whiteSpace, wordBreak, maxLinesCount } = _ref1, rest = _object_without_properties(_ref1, [
        "variant",
        "color",
        "className",
        "lineHeight",
        "whiteSpace",
        "wordBreak",
        "maxLinesCount"
    ]), [ref] = _rest;
    const theme = useTheme();
    const { classes } = useStyles({
        lineHeight,
        maxLinesCount
    });
    const body3 = classes.body3;
    return /*#__PURE__*/ jsx(Typography, _object_spread_props(_object_spread({}, rest), {
        ref: ref,
        variant: 'body3' !== variant ? variant : 'body2',
        color: "inherit",
        variantMapping: variantMapping,
        classes: classes,
        className: classnames(className, {
            [body3]: 'body3' === variant,
            [`aqa_${variant}`]: true,
            [classes.lineHeight]: true,
            [classes.trimLines]: !!maxLinesCount
        }),
        whiteSpace: whiteSpace,
        style: {
            wordBreak,
            color: 'inherit' === color ? 'inherit' : get(theme.tokens.colors, color)
        }
    }));
});
export { Typography_Typography as Typography, variantMapping };
